import * as React from 'react'
import type {HTMLAttributes} from 'react'
import {useFragment} from 'react-relay'

import LinearAgent from '../../../../../components/LinearAgent/LinearAgent'
import type {AssignAgentsDialogAgentFragment$key} from '../__generated__/AssignAgentsDialogAgentFragment.graphql'
import {agentFragment} from '../AssignAgentsDialog.queries'

type Props = HTMLAttributes<HTMLDivElement> & {
  agentRef: AssignAgentsDialogAgentFragment$key
  searchQuery: string
  className?: string
}

export function AgentItem({agentRef, className, searchQuery, ...htmlProps}: Props) {
  const {name, environment, connected, enabled} = useFragment(agentFragment, agentRef)

  if (name == null || environment == null) {
    return null
  }

  return (
    <LinearAgent
      className={className}
      title={name}
      osType={environment.os != null ? environment.os.type : null}
      connected={connected}
      enabled={enabled}
      searchQuery={searchQuery}
      {...htmlProps}
    />
  )
}
